import React, { createContext, useState, useContext, useEffect } from "react";
import { GetUserBridge, GetBridgeTriggers } from "../../services/backendServices";
import { USER_BRIDGE_TRIGGER_DIRECTION, STORAGE_KEYS } from "../../Util/key_helper";
import { toast } from "react-toastify";
// Create a context for BridgeData
export const CustomBridgeContext = createContext();
/*** CustomBridgeContextProvider: A provider component to manage and supply bridge and trigger data*/
export const CustomBridgeContextProvider = ({ children }) => {
    const [isUserBridgeDataLoading, setIsUserBridgeDataLodaing] = useState(true);  // State to track loading status for user bridge data 
    const [isUserBridgeDataFetched, setIsUserBridgeDataFetched] = useState(false); // state to track user bridge data has been fetched
    const [userBridgeData, setUserBridgeData] = useState([]); // state to store bridge data 
    const [bridgeTriggerData, setBridgeTriggerData] = useState([]); // state to store bridge trigger data
    const [isBridgeTriggerDataFetched, setIsBridgeTriggerDataFetched] = useState(false); // state to track trigger data has been fetched 
    const [isBridgeTriggerDataLoading, setIsBridgeTriggerDataLoading] = useState(true); // state to track laoding status for trigger data 
    // Function to fetch usr bridge data 
    const fetchUserBridgedata = async () => {
        try {
            setIsUserBridgeDataLodaing(true); // Start loading
            const res = await GetUserBridge();

            if (res.status) {
                setUserBridgeData(res.data);
                setIsUserBridgeDataFetched(true); // Mark data as fetched
            }
        } catch (e) {
            console.error("Error fetching user bridge:", e);
        } finally {
            setIsUserBridgeDataLodaing(false); // End loading
        }
    };

    // Function to fetch user bridge trigger data 
    const fetchUserBridgeTriggerData = async ({ bridge_id }) => {

        try {
            setIsBridgeTriggerDataLoading(true);
            const res = await GetBridgeTriggers({ bridge_id });

            if (res.status) {
                setBridgeTriggerData(res.data);
                setIsBridgeTriggerDataFetched(true); // Mark data as fetched
            }
        } catch (e) {
            console.error("Error fetching user bridge trigger data:", e);
        } finally {
            setIsBridgeTriggerDataLoading(false);
        }
    };


    // Function to update bridge data
    const updateBridgeData = (updatedData) => {
        setUserBridgeData((prevData) =>
            prevData.map((item) =>
                item.bridge_id === updatedData.bridge_id ? { ...item, ...updatedData } : item
            )
        );
    };

    // Function to update specific fields of a bridge in Bridge Data 
    const updateBridgeField = (bridge_id, updatedFields) => {
        setUserBridgeData((prevData) =>
            prevData.map((item) =>
                item.bridge_id === bridge_id ? { ...item, ...updatedFields } : item
            )
        );
    };

    // Function to remove bridge Dtaa
    const removeBridge = (bridge_id) => {
        setUserBridgeData((prevData) => prevData.filter((item) => item.bridge_id !== bridge_id));
    };


    const updateBridgeTriggerBridgeData = (bridge_id, updatedFields) => {
        setBridgeTriggerData(prevData => {
            if (!prevData || !prevData.bridge_data) {
                return prevData; // Return unchanged data if structure is invalid
            }

            // Check if bridge_id matches before updating
            if (prevData.bridge_data.bridge_id !== bridge_id) {
                return prevData; // Return unchanged data if IDs don't match
            }

            return {
                ...prevData,
                bridge_data: {
                    ...prevData.bridge_data,
                    ...updatedFields, // Update only the provided fields
                }
            };
        });
    };
    //function to add User Bridge Data 
    const addUserBridge = (resData) => {
        // Initially Count As Zero 
        const updatedData = { ...resData, overall_pnl: 0, today_pnl: 0, today_signal_count: 0, open_positions_count: 0 };

        // Update the state with the new data
        setUserBridgeData(prevData => [...prevData, updatedData]);
    };
    // Function to delete trigger and update priorities
    const deleteTriggerAndUpdatePriorities = (trigger_id) => {
        setBridgeTriggerData((prevData) => {
            const updatePriority = (triggers) =>
                triggers
                    .filter(trigger => trigger.trigger_id !== trigger_id) // Remove the trigger
                    .map((trigger, index) => ({ ...trigger, priority: index + 1 })); // Reset priority sequence

            return {
                ...prevData,
                up_triggers: updatePriority(prevData.up_triggers),
                down_triggers: updatePriority(prevData.down_triggers),
            };
        });
    };
    //Function to add New Trigger 
    const addBridgeTrigger = (newTrigger, direction) => {
        setBridgeTriggerData((prevData) => {
            const updatedTriggers = (triggers) => [...triggers, newTrigger];

            return {
                ...prevData,
                up_triggers: direction === USER_BRIDGE_TRIGGER_DIRECTION.UP
                    ? updatedTriggers(prevData.up_triggers)
                    : prevData.up_triggers,
                down_triggers: direction === USER_BRIDGE_TRIGGER_DIRECTION.DOWN
                    ? updatedTriggers(prevData.down_triggers)
                    : prevData.down_triggers,
            };
        });
    };
    // Function to update Bridge Trigger
    const updateBridgeTrigger = (updatedTrigger, direction) => {
        setBridgeTriggerData((prevData) => {
            const updateTriggerInArray = (triggers) =>
                triggers.map((trigger) =>
                    trigger.trigger_id === updatedTrigger.trigger_id ? updatedTrigger : trigger
                );

            return {
                ...prevData,
                up_triggers: direction === USER_BRIDGE_TRIGGER_DIRECTION.UP
                    ? updateTriggerInArray(prevData.up_triggers)
                    : prevData.up_triggers,
                down_triggers: direction === USER_BRIDGE_TRIGGER_DIRECTION.DOWN
                    ? updateTriggerInArray(prevData.down_triggers)
                    : prevData.down_triggers,
            };
        });
    };
    // Function To handle refresh Group Data 
    const handelRefreshUserBridgeData = async () => {
        try {
            await fetchUserBridgedata();
            toast.success("Data refreshed successfully!");
        } catch (error) {
            toast.error("Error refreshing data. Please try again.");
        }
    };
    useEffect(() => {
        const handleLoginStatusChange = (event) => {
            // Check if the specific key changed
            if (event.key === STORAGE_KEYS.BROKER_PANEL_USER_IS_LOGGIN_IN) {
                // Reset JSON bridge data when login status changes
                setIsBridgeTriggerDataFetched(false);
                setIsUserBridgeDataFetched(false)
            }
        };
        // Listen for storage changes (cross-tab)
        window.addEventListener("storage", handleLoginStatusChange);
        return () => {
            window.removeEventListener("storage", handleLoginStatusChange);
        };
    }, []);

    return (
        // The CustomBridgeContext.Provider component provides state and functions to the children components

        <CustomBridgeContext.Provider value={{
            userBridgeData, // provides a user bridge data 
            setUserBridgeData, // Provides the function to set/update the user bridge data
            isUserBridgeDataLoading,  // Provides the loading state of user bridge data 
            fetchUserBridgedata, // provides a function for fetch user bridge data 
            isUserBridgeDataFetched, // provides the fetched status of user bridge data 
            setIsUserBridgeDataFetched, //Provides a function to manually update the fetched status of user bridge
            updateBridgeData, // provides the function to update bridge data 
            fetchUserBridgeTriggerData, // provides a functio to fetch user bridge trigger data
            bridgeTriggerData,  // provides a bridge trigger data 
            setIsBridgeTriggerDataFetched, //Provides a function to manually update the fetched status of  bridge trigger 
            isBridgeTriggerDataLoading,  // Provides the loading state of bridge trigger data 
            isBridgeTriggerDataFetched, // provides the fetched status of bridge bridge data 
            setBridgeTriggerData, // Provides the function to set/update the  bridge  trigger data
            updateBridgeField, // provides a function to update the updated filled in bridge Data 
            removeBridge, // provides a function to remnove user bridge 
            updateBridgeTriggerBridgeData, // provides a function to update bridge trigger data 
            addUserBridge,  // procide a function to add user bridge data 
            deleteTriggerAndUpdatePriorities, // provides the function to delte trigger and update priorities
            addBridgeTrigger, // provides the function to add bridge trigger
            updateBridgeTrigger,  // provides the function to update bridge trigger
            handelRefreshUserBridgeData // provide the function to refresh user bridge data 
        }}>
            {children}
        </CustomBridgeContext.Provider>
    );
};
// Custom hook to access CustomBridgeContext data
export const useCustomBridgeContext = () => {
    return useContext(CustomBridgeContext);
};